import { DashboardsTextSize } from '@services/dashboards/types';
import { DashboardsData } from './types';

export const TEXT_SIZE_VALUES: DashboardsTextSize[] = [12, 14, 18, 28];

export const DEFAULT_TEXT_SIZE: DashboardsTextSize = 14;

export const initialState: DashboardsData = {
  presetId: '',
  sorting: [],
  saved: true,
  source: 'scheduled',
  columns: {
    records: [],
    isLoading: true,
  },
  preview: [[[]]],
  removedColumns: [],
  selectedColumns: [],
  checkedColumns: [],
  joinedColumns: [],
  initialColumns: [],
  textSize: DEFAULT_TEXT_SIZE,
  dialog: {
    column: {
      details: false,
      edit: false,
      settings: false,
      remove: false,
      values: {},
    },
    preset: {
      details: false,
      remove: false,
      values: {},
    },
  },
  tooltip: 0,
};
